






































import { defineComponent, PropType, ref } from "@vue/composition-api";
import i18n from "@/i18n";

interface Props {
  buttonLabel: string;
  clickHandler: () => Promise<void>;
  icon: string;
}

export default defineComponent({
  props: {
    buttonLabel: {
      type: String,
      default: i18n.t("generic.download"),
    },
    icon: {
      type: String,
      default(): string {
        return "mdi-download";
      },
    },
    clickHandler: {
      type: Function as PropType<() => Promise<void>>,
    },
  },
  setup(props: Props) {
    const isLoading = ref(false);
    function onClick() {
      isLoading.value = true;

      props
        .clickHandler()
        .then((): void => {
          isLoading.value = false;
        })
        .catch(() => {
          isLoading.value = false;
        });
    }

    return { onClick, isLoading };
  },
});
